import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;

  p {
    font-weight: 600;
    font-size: 16px;
  }

  .card-news-image {
    max-width: 100%;
    max-height: 100%;
    height: auto;
    width: auto;
    object-fit: contain;
    cursor: pointer;
  }
`;
